import React from "react";

export const Sphere3D = ({ background = "blue" }) => {
  return <div className="sphere-3d" style={{ background: background }}></div>;
};
